import type { BaseUser } from '@helpers/auth/types';

export const getUserDisplayName = (user: BaseUser) => `${user.firstName} ${user.lastName}`;
